import React from 'react';
import { Input } from 'rsuite';
import { InputProps } from 'rsuite/cjs/Input/Input';

interface TextareaProps extends InputProps {
  rows?: number;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Input {...props} as="textarea" ref={ref} />
));

Textarea.defaultProps = {
  rows: 3,
};

export default Textarea;
